import { NIGHT_TINT, TAP_LIMIT } from 'app/constants/AppConstants.js';
import Heart from '../Heart';
import { TAP_TIME } from './items/Item';

const COSTUMES = ['body', 'lifejacket', 'raincoat', 'pyjamas'];

export default class Character extends Phaser.Sprite {
  /* eslint-disable max-statements */
  constructor(game, location, id, data) {
    super(game, 0, 0);

    this.location = location;
    this.id = id;
    this.data = data;

    this.dz = 0;

    this.isRabbit = id === 'rabbit';

    //
    this.onChange = new Phaser.Signal();

    this.asset = this.game.make.spine(0, 0, id, true);
    this.asset.anchor.set(0.5, 1);
    this.addChildAt(this.asset, 0);

    // get root bone
    this.rootBone = this.asset.skeleton.getRootBone();
    this.scaleDefault = this.rootBone.scaleX;

    this.mixAnims();
    // if (!this.isRabbit) this.createSkins();

    //
    this.inTent = false;
    this.isEating = false;
    this.inSleepingBag = false;
    this.costumeInd = 0;
    this.hat = null; // stores hats name
    this.setSkin(COSTUMES[this.costumeInd]);

    //
    this.setAnim('idle');

    //
    this.addButton();

    // get anchors
    this.anchorPos1 = new Phaser.Point(0, 0);
    this.anchor1 = this.asset.skeleton.findBone('anchor_1');
    this.anchor2 = this.asset.skeleton.findBone('anchor_2');
    this.anchorMouth = this.asset.skeleton.findBone('anchor_mouth');
    if (this.anchor1) {
      // dot to mark rotation center
      this.slot1 = this.game.make.group(); // left slot
      this.slot2 = this.game.make.group(); // right slot
      this.addChild(this.slot1);
      this.addChild(this.slot2);
    }

    //
    this.addChomp();

    // scale it down
    this.setScale(0.4);
    this.headY = this.button.height * 0.85;
  }
  /* eslint-enable */

  mixAnims() {
    this.asset.setMixByName('hands_empty', 'hands_holding', 0.4);
    this.asset.setMixByName('hands_holding', 'hands_empty', 0.4);
    this.asset.setMixByName('idle', 'pickup', 0.2);
    this.asset.setMixByName('pickup', 'idle', 0.2);
    this.asset.setMixByName('idle', 'eating', 0.2);
    this.asset.setMixByName('eating', 'idle', 0.2);
    if (!this.isRabbit) {
      this.asset.setMixByName('idle', 'sleeping', 0.2);
      this.asset.setMixByName('sleeping', 'idle', 0.2);
      this.asset.setMixByName('idle', 'float', 0.2);
      this.asset.setMixByName('float', 'idle', 0.2);
    }
  }

  createSkins() {
    const skins = [
      'body',
      'lifejacket',
      'raincoat',
      'pyjamas',
      'sleeping_bag_1',
      'sleeping_bag_2',
      'sleeping_bag_3',
    ];
    const hats = ['hat_1', 'hat_2', 'hat_3'];
    for (let i = 0; i < skins.length; i++) {
      for (let j = 0; j < hats.length; j++) {
        console.log(skins[i] + hats[j]);
        this.asset.createCombinedSkin(skins[i] + hats[j], skins[i], hats[j]);
      }
    }
  }

  addChomp() {
    const x = this.anchorMouth.worldX * 0.4;
    const y = -this.anchorMouth.worldY * 0.4;
    this.chomp = this.game.make.spine(x, y, 'spine_chomp', true);
    this.chomp.anchor.set(0.5, 1);
    this.addChild(this.chomp);
    this.chomp.visible = false;
  }

  get depth() {
    const d = this.y + this.dz + (this.drag ? 2000 : 0);
    return d;
  }

  init(data) {
    this.hat = data.hat;

    if (data.costumeInd !== undefined && data.costumeInd !== null) {
      this.costumeInd = data.costumeInd;
      this.setSkin(COSTUMES[this.costumeInd]);
    }

    if (data.sleeping_bag) {
      this.wearSleepingBag({ id: data.sleeping_bag });
    }

    this.inPond = data.in_pond;
    if (this.inPond) {
      this.pond = this.location.pond;
    }
  }

  setScale(scale) {
    this.rootBone.scaleX = scale * this.scaleDefault;
    this.rootBone.scaleY = scale * this.scaleDefault;

    const rb = this.chomp.skeleton.getRootBone();
    rb.scaleX = rb.scaleY = scale * this.scaleDefault;

    this.button.width = this.asset.width * 0.4 * this.rootBone.scaleX;
    this.button.height = this.asset.height * 0.9 * this.rootBone.scaleY;
  }

  setAnim(name, channel = 0, loop = true) {
    if (channel === 0) {
      // store anim anme only for main anim
      this.animName = name;
    }
    this.currentAnim = this.asset.setAnimationByName(channel, name, loop);

    if (name === 'eating') {
      this.chomp.visible = true;
      this.chomp.setAnimationByName(0, 'animation', false);
    }
  }

  setSkin(name) {
    if (this.isRabbit) return;

    this.skinName = name;
    const sx = this.rootBone.scaleX;
    const sy = this.rootBone.scaleY;
    const rt = this.rootBone.rotation;
    if (this.hat) {
      const skin = this.asset.createCombinedSkin(name + this.hat, this.hat, name);
      this.asset.setSkin(skin);
    } else {
      this.asset.setSkinByName(name);
    }
    this.asset.setToSetupPose();
    this.rootBone.scaleX = sx;
    this.rootBone.scaleY = sy;
    this.rootBone.rotation = rt;
  }

  pauseAnim() {
    this.currentAnim.timeScale = 0;
  }

  unpauseAnim() {
    this.currentAnim.timeScale = 1;
  }

  //
  setLight(power) {
    const r0 = 1;
    const g0 = 1;
    const b0 = 1;

    const tint = NIGHT_TINT;
    const r1 = (tint >> 16) / 255;
    const g1 = ((tint >> 8) & 0x00ff) / 255;
    const b1 = (tint & 0x0000ff) / 255;

    this.asset.skeleton.color.r = r1 + power * (r0 - r1);
    this.asset.skeleton.color.g = g1 + power * (g0 - g1);
    this.asset.skeleton.color.b = b1 + power * (b0 - b1);
  }

  //
  addButton() {
    this.button = this.game.make.button(0, 0, 'empty');
    this.button.width = this.asset.width * 0.4;
    this.button.height = this.asset.height * 0.9;
    this.button.anchor.set(0.5, 1);
    this.button.alpha = 0;
    this.addChild(this.button);

    // events
    this.button.events.onInputDown.add(this.handleInputDown, this);
    if (this.game.deviceMetric.platform.type === 'desktop') {
      // desktop
      this.button.events.onInputOver.add(this.handleInputOver, this);
      this.button.events.onInputOut.add(this.handleInputOut, this);
    } else {
      // mobile
      this.button.events.onInputUp.add(this.handleInputUp, this);
    }
    this.button.input.useHandCursor = true;
  }

  /* eslint-disable max-statements */
  handleInputDown(target, pointer) {
    this.handleInputOut();

    if (this.drag) {
      this.handleInputUp();
    } else {
      this.location.state.interacted(this);
      // try to pickup hat
      if (this.hat) {
        const bb1 = this.button.getBounds();
        const y0 = pointer.positionDown.y;
        const y1 = bb1.y + bb1.height - y0;
        if (y1 / bb1.height > 0.7) {
          // pickup hat
          this.pickupHat(pointer);
          return;
        }
      }

      //
      this.location.startDragItem(this);
      this.drag = true;

      // remove furniture it is sitting at
      if (this.furniture) {
        this.furniture.isEmpty = true;
        this.furniture = null;
        this.sitPoint.top.empty = true;
        this.sitPoint.empty = true;
        this.sitPoint = null;
        this.isSitting = false;
      }

      this.dz = 0;
      this.parentObj && this.parentObj.removeObject(this);
      this.parentObj = null;

      this.dragStartX = pointer.x;
      this.dragStartY = pointer.y;
      this.dragDx = this.x - (pointer.x - this.location.x);
      this.dragDy = this.y - pointer.y;
      if (this.button.angle !== 0) {
        const c = Math.cos(-this.button.rotation);
        const s = Math.sin(-this.button.rotation);
        const dx = this.dragDx * c - this.dragDy * s;
        const dy = this.dragDx * s + this.dragDy * c;
        this.dragDx = dx;
        this.dragDy = dy;
      }
      this.pointer = pointer;

      this.parent.bringToTop(this);

      this.setScale(0.45);
      this.setAngle(0);
      this.setAnim('pickup', 0);
    }
  }
  /* eslint-enable */

  handleInputUp() {
    //
    if (this.pointer) {
      const dx = Math.abs(this.pointer.x - this.dragStartX);
      const dy = Math.abs(this.pointer.y - this.dragStartY);

      // if drag dist < 2 change costume or remove sleeping bag
      if (dx < TAP_LIMIT && dy < TAP_LIMIT && !this.isRabbit) {
        this.handleTap();
      }

      //
      this.setScale(0.4);
      this.setAnim('idle', 0);

      //
      this.location.stopDragCharacter(this);
      this.drag = false;
      this.pointer = null;

      this.checkPose();
    } else {
      // release hat
      this.hatRef.handleInputUp();
      this.hatRef = null;
    }
  }

  handleTap() {
    if (this.inSleepingBag) {
      this.leaveSleepingBag();
    } else {
      this.costumeInd++;
      this.costumeInd %= 4;
      this.setSkin(COSTUMES[this.costumeInd]);
      this.game.sounds.playSFX('item_clothing', { spriteID: 'sfx' });

      //
      if (this.skinName === 'raincoat' && !this.location.isDay()) this.showHeart();
      if (this.skinName === 'body' && this.location.isDay()) this.showHeart();

      //
      this.onChange.dispatch('set skin');
    }
  }

  canHover() {
    return !this.drag && !this.tent && !this.isRabbit;
  }

  handleInputOver() {
    if (!this.location.isDraggingItem) {
      this.setScale(0.42);
    }

    if (this.canHover()) {
      this.isHover = true;
      this.hoverTime = 0;
      this.location.state.gameHud.showHoverGauge(
        this.worldPosition.x,
        this.worldPosition.y - this.height - 50
      );
    }
  }

  handleInputOut() {
    this.setScale(0.4);

    if (this.isHover) {
      this.isHover = false;
      this.location.state.gameHud.hideHoverGauge();
    }
  }

  //
  fallDownTo(destY) {
    this.destY = destY;
    this.speedY = 0;
    this.isFalling = true;
  }

  //
  checkIfItemIsClose(item) {
    if (this.hasEmptyHands() && !this.inSleepingBag && !this.inTent && this.animName !== 'float') {
      const x0 = this.worldPosition.x;
      const y0 = this.worldPosition.y - this.button.height / 2;
      const x1 = item.worldPosition.x;
      const y1 = item.worldPosition.y - item.height / 2;
      const dx = x1 - x0;
      const dy = y1 - y0;
      const dist = dx * dx + dy * dy;

      if (dist < 150 * 150) {
        this.setAnim('hands_holding', 1);
      } else {
        // this.setAnim('hands_empty', 1);
        this.asset.state.setEmptyAnimation(1, 0.2);
      }
    }
  }

  // hats
  getHeadPos() {
    const pt0 = new Phaser.Point(0, -this.headY);
    const pt1 = Phaser.Point.rotate(pt0, 0, 0, this.button.angle, true);
    return pt1;
  }

  canWearHat(item) {
    if (!this.hat && !this.isRabbit) {
      const pt = this.getHeadPos();
      pt.x += this.worldPosition.x;
      pt.y += this.worldPosition.y;
      const bb2 = item.bb;
      if (Phaser.Rectangle.containsPoint(bb2, pt)) {
        return true;
      }
    }

    return false;
  }

  wearHat(item) {
    this.hat = item.id;
    this.setSkin(this.skinName);

    //
    this.onChange.dispatch('wear hat');
  }

  pickupHat(pointer) {
    const item = this.location.addItem(this.hat, pointer.x, pointer.y);
    this.location.saveItems();
    item.handleInputDown(null, pointer);

    this.hatRef = item;

    this.hat = null;
    this.setSkin(this.skinName);

    this.onChange.dispatch('wear hat');
  }

  // sleeping bag
  canWearSleepingBag(item) {
    if (!this.inSleepingBag && !this.isRabbit) {
      const bb1 = this.button.getBounds();
      const bb2 = item.bb;
      if (Phaser.Rectangle.intersects(bb1, bb2)) {
        return true;
      }
    }

    return false;
  }

  wearSleepingBag(item) {
    this.inSleepingBag = true;

    //
    if (this.skinName === 'pyjamas') this.showHeart();

    //
    const skin = item.id.substring(0, item.id.indexOf('_open'));
    this.setSkin(skin);
    this.dropItems();

    this.game.sounds.playSFX('item_rucksack', { spriteID: 'sfx' });

    //
    this.onChange.dispatch('wear sleeping bag');
  }

  leaveSleepingBag() {
    const itemId = this.skinName + '_open';
    this.setSkin(COSTUMES[this.costumeInd]);
    this.inSleepingBag = false;
    this.location.addItem(itemId, this.x, this.y);
    this.location.saveItems();

    //
    this.onChange.dispatch('leave sleeping bag');
  }

  // return anchor where item can be put
  canPutItemIntoHand(item) {
    if (
      this.anchor1 &&
      this.hasOneEmptyHand() &&
      !this.inSleepingBag &&
      !this.inTent &&
      this.animName !== 'float'
    ) {
      const anchors = [this.anchor1, this.anchor2];
      const slots = [this.slot1, this.slot2];
      for (let i = 0; i < 2; i++) {
        const anchor = anchors[i];
        const slot = slots[i];
        if (slot.length === 0) {
          // slot is empty
          const x = this.worldPosition.x + anchor.worldX;
          const y = this.worldPosition.y - anchor.worldY;
          const bb = item.getBounds();
          const x1 = bb.x + bb.width * 0.5;
          const y1 = bb.y + bb.height * 0.5;
          const dx = Math.abs(x1 - x);
          const dy = Math.abs(y1 - y);
          if (dx < 40 && dy < 40) {
            return slot;
          }
          // const pt = { x, y };
          // const bb = item.getBounds();
          // if (Phaser.Rectangle.containsPoint(bb, pt)) {
          //   return slot;
          // }
        }
      }
    }

    return null;
  }

  putItemIntoHand(item, slot) {
    item.putInHand(this, slot === this.slot1);
    slot.addChild(item);
    this.setAnim('hands_holding', 1);
  }

  dropItems() {
    if (!this.hasEmptyHands()) {
      if (this.slot1.length > 0) {
        this.slot1.children[0].drop();
      }
      if (this.slot2.length > 0) {
        this.slot2.children[0].drop();
      }
      this.checkPose();
    }
  }

  pickupItemFromHand() {
    // if (this.hasEmptyHands()) {
    //   this.setAnim('idle');
    // }
  }

  //
  checkIfItemIsCloseToMouth(item) {
    if (this.canPutFoodIntoMouth(item)) {
      if (!this.mouthOpen) {
        this.mouthOpen = true;
        this.asset.setAnimationByName(2, 'open_mouth', false);
      }
    } else if (this.mouthOpen) {
      this.mouthOpen = false;
      this.asset.state.setEmptyAnimation(2, 0.1);
    }
  }

  canPutFoodIntoMouth(item) {
    if (!this.isEating) {
      // slot is empty
      const x0 = this.worldPosition.x + this.anchorMouth.worldX;
      const y0 = this.worldPosition.y - this.anchorMouth.worldY;
      const bb = item.getBounds();
      const x1 = item.worldPosition.x;
      const y1 = item.worldPosition.y - bb.height * 0.5;
      const dx = x1 - x0;
      const dy = y1 - y0;
      const dist = dx * dx + dy * dy;
      if (dist < 30 * 30) {
        return true;
      }
    }

    return false;
  }

  eat(item, colour) {
    if (!this.isEating) {
      this.isEating = true;
      this.checkPose();
      this.game.time.events.add(50, this.setAnim, this, 'eating', 2, false);
      this.asset.onComplete.addOnce(this.handleEatingEnd, this);

      //
      this.game.sounds.playSFX('item_eating', { spriteID: 'sfx' });

      // set colour
      const c = parseInt(colour, 16);
      const r = (c >> 16) / 255;
      const g = ((c >> 8) & 0x00ff) / 255;
      const b = (c & 0x0000ff) / 255;

      this.chomp.skeleton.color.r = r;
      this.chomp.skeleton.color.g = g;
      this.chomp.skeleton.color.b = b;

      // check if it is favourite food
      if (!this.isRabbit && (!item.isStick || item.isCooked())) {
        if (this.data.food.indexOf(item.id) > -1) {
          this.showHeart();
        }
      }
    }
  }

  handleEatingEnd() {
    this.isEating = false;
    this.asset.state.setEmptyAnimation(2, 0.2);
  }

  // sitting
  canSit(sitPoint) {
    if (!this.inSleepingBag) {
      const dx = Math.abs(sitPoint.x - this.x);
      const offset = this.isRabbit ? 150 : 45;
      const dy = Math.abs(sitPoint.y - (this.y - offset));
      const range = this.isRabbit ? 50 : 30;
      if (dx < 30 && dy < range) {
        return true;
      }
    }
    return false;
  }

  sitDown(furniture, sitPoint) {
    const { x, y, dz } = sitPoint;
    sitPoint.empty = false;
    sitPoint.top.empty = false;

    this.isSitting = true;
    this.furniture = furniture;
    this.sitPoint = sitPoint; // reference to sit point
    this.furniture.isEmpty = false;
    this.x = x;
    const offset = this.isRabbit ? 150 : 45;
    this.y = y + offset;
    this.setAnim('sitting', 0, true);
    this.dz = dz - 44;

    this.onChange.dispatch('sit down');
  }

  //
  checkPose() {
    if (!this.inTent) {
      if (this.hasEmptyHands()) {
        // this.setAnim('hands_empty', 1);
        this.asset.state.setEmptyAnimation(1, 0.2);
      } else {
        this.setAnim('hands_holding', 1);
      }
    }
  }

  hasEmptyHands() {
    return this.slot1.length === 0 && this.slot2.length === 0;
  }

  hasOneEmptyHand() {
    return this.slot1.length === 0 || this.slot2.length === 0;
  }

  canFloat() {
    return false;
  }

  pickupFromPond() {
    this.inPond = false;
    this.pond = null;
    this.dz = 0;
  }

  putIntoTent(tent, data) {
    this.x = data.x;
    this.y = data.y;
    this.setAngle(data.angle);
    this.setAnim('sleeping', 0);
    this.inTent = true;
    this.tent = tent;

    if (this.inSleepingBag && tent.id === this.data.tent && !this.location.isDay())
      this.showHeart();
  }

  pickupFromTent() {
    this.setAnim('idle', 0);
    this.inTent = false;
    this.tent.empty = true;
    this.tent = null;
  }

  setAngle(angle) {
    this.rootBone.rotation = -angle;
    this.button.angle = angle;
  }

  showHeart() {
    const pt = this.getHeadPos();
    const heart = new Heart(this.game, pt.x, pt.y - 20);
    this.addChild(heart);
  }

  //
  update() {
    this.asset.update();
    this.chomp.update();
    super.update();

    //
    if (this.anchor1) {
      this.slot1.x = this.anchor1.worldX;
      this.slot1.y = -this.anchor1.worldY;
      this.slot2.x = this.anchor2.worldX;
      this.slot2.y = -this.anchor2.worldY;
    }
  }

  /* eslint-disable max-statements */
  step(dt) {
    // light
    const power = this.location.lights.getLightAt(
      this.worldPosition.x,
      this.worldPosition.y - (this.height >> 1),
      true
    );
    if (power >= 0 && power !== this.lightPower) {
      this.lightPower = power;
      this.setLight(power);
    }

    // hover
    if (this.game.deviceMetric.platform.type === 'desktop') {
      if (this.isHover) {
        this.hoverTime += dt;
        const value = Math.min(1, this.hoverTime / TAP_TIME);
        this.location.state.gameHud.setHoverValue(value);
        if (this.hoverTime > TAP_TIME) {
          this.handleInputOut();
          this.handleTap();
        }
      }
    }

    if (this.drag && this.pointer) {
      // console.log(this.pointer.x, this.pointer.y);
      this.x = -this.location.x + this.pointer.x + this.dragDx;
      this.x = Phaser.Math.clamp(this.x, 50, this.location.width - 50);
      this.y = Math.min(720, this.pointer.y + this.dragDy);
    } else if (this.isFalling) {
      this.speedY += 50 * dt;
      this.y += this.speedY;
      if (this.y > this.destY) {
        // reached destination position
        this.y = this.destY;
        this.isFalling = false;
        if (!this.parentObj) {
          this.dz = 0;
        } else {
          this.dz = this.destDZ;
        }

        // splash sound if in water
        if (this.inPond) {
          this.game.sounds.playSFX('item_splash', { spriteID: 'sfx' });

          if (this.skinName === 'lifejacket') this.showHeart();
        }

        //
        this.onChange.dispatch('on position');
      }
    }

    // in water anim control
    if (!this.isRabbit && this.inPond && this.pond) {
      if (this.pond.waterLevel === 1) {
        // swim
        if (this.animName === 'idle') {
          this.setAnim('float', 0);
          this.dropItems();
        }
      } else if (this.animName === 'float') {
        this.setAnim('idle', 0);
      }
    }
  }
  /* eslint-enable */

  //
  serialize() {
    const data = { id: this.id, x: this.x, y: this.y, costumeInd: this.costumeInd };
    if (this.inSleepingBag) {
      data.sleeping_bag = this.skinName + '_open';
    }

    data.in_tent = this.inTent;
    data.tent = this.tent ? this.tent.id : null;
    data.hat = this.hat;

    data.in_pond = this.inPond;

    return data;
  }
}
